export const countries = [
  {
    id: 'egypt',
    name: 'مصر',
    nameEn: 'Egypt',
    currency: 'EGP',
    currencyName: 'جنيه مصري',
    currencySymbol: 'ج.م',
    flag: '🇪🇬',
  },
  {
    id: 'uae',
    name: 'الإمارات',
    nameEn: 'UAE',
    currency: 'AED',
    currencyName: 'درهم إماراتي',
    currencySymbol: 'د.إ',
    flag: '🇦🇪',
  },
  {
    id: 'saudi',
    name: 'السعودية',
    nameEn: 'Saudi Arabia',
    currency: 'SAR',
    currencyName: 'ريال سعودي',
    currencySymbol: 'ر.س',
    flag: '🇸🇦',
  },
  {
    id: 'kuwait',
    name: 'الكويت',
    nameEn: 'Kuwait',
    currency: 'KWD',
    currencyName: 'دينار كويتي',
    currencySymbol: 'د.ك',
    flag: '🇰🇼',
  },
];

export const getCountryById = (id) => countries.find((c) => c.id === id);
